export const UserTypes = {
  GET_USER: "GET_USER",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_LOGO: "UPDATE_LOGO",
  REMOVE_LOGO: "REMOVE_LOGO",
  RESET_USER: "RESET_USER",
  RESET_CODE_VERIFICATION: "RESET_CODE_VERIFICATION",
};
